import IRolePredicate from "../models/IRolePredicate";
import { fetchSecureData } from "../utils";

export const saveUpdatedRolePredicate = async (
  accessToken: string,
  rolePredicate: IRolePredicate
) => {
  const payload = {
    roleId: rolePredicate.roleId,
    // tslint:disable-next-line:object-literal-sort-keys
    predicateId: rolePredicate.predicateId,
    value: rolePredicate.value,
    isEnabled: rolePredicate.isEnabled
  };
  try {
    const data = await fetchSecureData(
      "PUT",
      `/api/RolePredicate/Edit`,
      accessToken,
      payload
    );
    const result = ((await data.json()) as any).value as IRolePredicate;
    // tslint:disable-next-line:no-console
    return result;
  } catch (err) {
    // tslint:disable-next-line:no-console
    console.log(`Fetch error for /api/RolePredicate/Edit`, err);
  }
  return {} as IRolePredicate;
};

export default saveUpdatedRolePredicate;
